import React from 'react';
import Header from '../../../../components/App/header/Header';
import logo from '../../assets/ofc-serenity-eu__OcfLogo.png';

type HeaderType = typeof Header;

// @ts-ignore exotic component
const HeaderOFC: HeaderType = (props) => <Header {...props} logoIcon={logo} />;
export default HeaderOFC;
